module.exports = __webpack_public_path__ + "img/embedded1.b96dda21.png";